import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions} from '@angular/http';
import {GlobalDataService} from "./global-data.service";

@Injectable()
export class HttpClientService {

  constructor(private http: Http, private globalDataService: GlobalDataService) {}

  createAuthorizationHeader(headers: Headers) {
    if (this.globalDataService.token != null) {
      headers.append('token', this.globalDataService.token);
    }
    if (this.globalDataService.loginType != null) {
      headers.append('login-type', this.globalDataService.loginType);
    }
    if (this.globalDataService.loginType == "skyswitch") {
      if (this.globalDataService.refreshToken != null) {
        headers.append('refresh-token', this.globalDataService.refreshToken);
      }
      if (this.globalDataService.skyLogin != null) {
        headers.append('sky-login', this.globalDataService.skyLogin);
      }
    }
  }

  get(url, headers = null, params = null) {
    if (headers == null){
      headers = new Headers();
    }
    this.createAuthorizationHeader(headers);
    const options: RequestOptions = new RequestOptions({ headers: headers, params: params });
    return this.http.get(url, options);
  }

  post(url, data, headers = null, responseType = null) {
    if (headers == null){
      headers = new Headers();
    }
    this.createAuthorizationHeader(headers);
    const options: RequestOptions = new RequestOptions({ headers: headers });
    if (responseType != null)
    {
      options.responseType = responseType;
    }
    return this.http.post(url, data, options);
  }
}



// WEBPACK FOOTER //
// ./src/app/http-client.service.ts